import { render, staticRenderFns } from "./UploadImgs.vue?vue&type=template&id=c575cd6c"
import script from "./UploadImgs.vue?vue&type=script&lang=js"
export * from "./UploadImgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports